import service from '@/utils/request';

// 登录场景配置列表

export var sceneList = function sceneList(data) {
  return service({
    url: "/xcpGameData/scene/sceneList",
    method: 'post',
    data: data
  });
};
export var sceneListAll = function sceneListAll(data) {
  return service({
    url: "/xcpGameData/scene/sceneListAll",
    method: 'post',
    data: data
  });
};